import { render } from "./my-button.vue?vue&type=template&id=79c3c170&scoped=true"
import script from "./my-button.vue?vue&type=script&lang=js"
export * from "./my-button.vue?vue&type=script&lang=js"

import "./my-button.vue?vue&type=style&index=0&id=79c3c170&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c3c170"]])

export default __exports__